var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    _vm._g(
      {
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          width: "32",
          height: "32",
          fill: "none"
        }
      },
      _vm.$listeners
    ),
    [
      _c("path", {
        attrs: {
          fill: "#4868FD",
          d:
            "M0 4a4 4 0 0 1 4-4h24a4 4 0 0 1 4 4v24a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4Z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FFE252",
          d:
            "M16.274 14.354a4.617 4.617 0 1 0 0-9.234 4.617 4.617 0 0 0 0 9.234ZM26.652 27.154H5.669v-1.691a9.306 9.306 0 0 1 9.326-9.326h2.331a9.306 9.306 0 0 1 9.326 9.326v1.691Z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#02016F",
          d:
            "M22.172 19.063c.045-.046.091-.046.091-.092.274-.183.823-.685.869-.823a9.666 9.666 0 0 0-1.201-.803c-.595.548-.765.575-1.177 1.032-.137.183-.365.183-.73.457-.092.046-.184.137-.32.183.09-.091-.23.046-.092-.046-.549.366-.366.275-.96.503-1.143-.091-.366.366-1.783.229h.091c-.32 0-1.234.137-.411.091-.595.183-1.417-.046-.183-.046-.137-.045-.457.046-.32-.045-.137.091-1.189-.046-.777-.092-.229 0-.457-.091-.686-.137.457.092.091.092.274.137-.594-.045-.32-.183-.96-.32.823.275-1.554-.411-1.051-.365-.823-.412-.777-.366-1.097-.686-.092-.046-.549-.32-.32-.229-.137-.045-.412-.274 0-.091-.137-.092-.751-.579-.818-.702 0 0-.504.248-.686.371-.182.123-.646.493-.646.493.183.412 1.327 1.072.915 1.026.23 0 1.098.458.458.366.091.046.183.137.365.274-.137-.32.183.046.366.23-.137-.138.412-.047.092.045.137.046.274.091.411.091-.091-.046-.046.092 0 .137-.046-.045.32.137.411.183l-.137-.091c.777.274.915.32 1.783.503-.914 0-.32.137-.548.137.868.137 2.057.274 3.108.274.64-.046 1.6-.366 2.194-.32.046-.046.092-.046.229-.091-.046-.092 2.469-.869 3.246-1.783Z"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }